module.exports = __webpack_public_path__ + "static/media/q2.44be53de.png";